import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetUnderstaffedRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetUnderstaffedResponseDtoSchema = z.object({
  count: z.number().nullable(),
  changePct: z.number().nullable(),
});

export type GetUnderstaffedRequestDto = z.infer<
  typeof _GetUnderstaffedRequestDtoSchema
>;
export type GetUnderstaffedResponseDto = z.infer<
  typeof GetUnderstaffedResponseDtoSchema
>;

export const getUnderstaffed = (
  params: GetUnderstaffedRequestDto,
  config?: AxiosRequestConfig<GetUnderstaffedRequestDto>
) => {
  return api
    .get('/staff/understaffed', {
      params,
      ...config,
    })
    .then(responseContract(GetUnderstaffedResponseDtoSchema));
};
